import '../scss/app.scss'
import 'bootstrap'
import { Swiper, Autoplay } from 'swiper'
import GLightbox from 'glightbox'
import '../../../node_modules/glightbox/dist/css/glightbox.min.css'

Swiper.use([Autoplay])

let sliders = document.querySelectorAll('[data-component="Slider"]')
sliders = [...sliders].map(
  (slider) =>
    new Swiper(slider.querySelector('.swiper-container'), {
      autoplay: {
        delay: 3000,
      },
      slidesPerView: 4,
      spaceBetween: 40,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        769: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    }),
)

const lightbox = GLightbox()
